import React, { useState } from 'react';
import socket from '../socket';
import PokemonCard from './PokemonCard';

function PokemonPicker({ pickData }) {
  const { board, roomCode, players, playerId, boardSize } = pickData;
  const [selectedId, setSelectedId] = useState(null);
  const [confirmed, setConfirmed] = useState(false);
  const [opponentReady, setOpponentReady] = useState(false);

  React.useEffect(() => {
    socket.on('opponent-picked', () => {
      setOpponentReady(true);
    });

    return () => {
      socket.off('opponent-picked');
    };
  }, []);

  const handleCardClick = (pokemon) => {
    if (confirmed) return;
    setSelectedId(pokemon.id);
  };

  const handleConfirm = () => {
    if (!selectedId || confirmed) return;
    setConfirmed(true);
    socket.emit('pick-secret', { roomCode, pokemonId: selectedId });
  };

  const myName = players.find(p => p.id === playerId)?.name || 'You';
  const opponentName = players.find(p => p.id !== playerId)?.name || 'Opponent';

  return (
    <div className="picker">
      <div className="picker-header">
        <h1 className="lobby-title">Pick Your Secret Pokemon</h1>
        <p className="picker-subtitle">
          Choose the Pokemon your opponent must guess
        </p>
      </div>

      <div className="picker-status">
        <span className={`picker-player ${confirmed ? 'ready' : ''}`}>
          {myName}: {confirmed ? 'Ready!' : 'Picking...'}
        </span>
        <span className={`picker-player ${opponentReady ? 'ready' : ''}`}>
          {opponentName}: {opponentReady ? 'Ready!' : 'Picking...'}
        </span>
      </div>

      <div className={`pokemon-board picker-board ${boardSize === 36 ? 'board-36' : ''}`}>
        {board.map((pokemon) => (
          <PokemonCard
            key={pokemon.id}
            pokemon={pokemon}
            eliminated={false}
            onClick={() => handleCardClick(pokemon)}
            selectable={!confirmed}
            selected={selectedId === pokemon.id}
          />
        ))}
      </div>

      {!confirmed && (
        <div className="picker-actions">
          <button
            type="button"
            className="btn btn-create"
            onClick={handleConfirm}
            onTouchEnd={(e) => { e.preventDefault(); handleConfirm(); }}
            disabled={!selectedId}
          >
            {selectedId
              ? `Confirm: ${board.find(p => p.id === selectedId)?.name}`
              : 'Select a Pokemon'}
          </button>
        </div>
      )}

      {confirmed && !opponentReady && (
        <div className="picker-waiting">
          <div className="waiting-spinner"></div>
          <p>Waiting for {opponentName} to pick...</p>
        </div>
      )}
    </div>
  );
}

export default PokemonPicker;
